jQuery(document).ready(function($) {

  $('.to-top-btn').click(function(e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 1000);
  });

  if ($('.is-style-cards')) {
    $('.is-style-cards .wp-block-columns').append('<div class="ornament"></div>');
    var h1Text = $('.is-style-cards .wp-block-group__inner-container > h1').html();

    $('.is-style-cards .wp-block-columns > .wp-block-column > .wp-block-image:first-child').each(function() {
      var img = $(this).html();
      $(this).html('<div class="img-wrapper">' + img + "</div>");
    });

    $('.is-style-cards .wp-block-group__inner-container > h1').html('<div class="text">' + h1Text + '</div>').append('<div class="ornament"></div>');
    $('.is-style-cards .wp-block-columns > .wp-block-column > .wp-block-image:first-child').append('<div class="ornament"></div>');
    $('.is-style-cards .wp-block-columns > .wp-block-column:first-child > .wp-block-image:first-child').append('<div class="ornament-secondary"></div>');
  }

  if ($('.wp-block-media-text:not(is-style-featured)')) {

    $('.wp-block-media-text:not(.is-style-featured):not(.is-style-text-focus)').each(function(index, element) {
      var img = $(element).find('.wp-block-media-text__media').html();
      $(element).find('.wp-block-media-text__media').html('<div class="img-wrap">' + img + '</div>');
      $(element).find('.wp-block-media-text__media').append('<div class="ornament-back-a"></div><div class="ornament-front-a"></div><div class="hand-ornament"></div>');
      $(element).find('.wp-block-media-text__content').append('<div class="line-ornament"></div>');
      if ($(element).parent('.wp-block-group__inner')) {
        var group = $(element).closest('.wp-block-group');
        if ($(group).next()) {
          $(group).next().addClass('offset-stars-padding');
        }
      }
    });

    $('.wp-block-media-text.is-style-text-focus').each(function(index, element) {
      var img = $(element).find('.wp-block-media-text__media').html();
      $(element).find('.wp-block-media-text__media').html('<div class="img-wrap">' + img + '</div>');
      $(element).find('.wp-block-media-text__media').append('<div class="ornament-back-a"></div><div class="ornament-back-b"></div><div class="ornament-front-b"></div>');
      $(element).find('.wp-block-media-text__content').append('<div class="img-wrap"><div class="img-wrap-inner">' + img + '</div></div>');
      if ($(element).parent('.wp-block-group__inner')) {
        var group = $(element).closest('.wp-block-group');
        if ($(group).next()) {
          $(group).next().addClass('offset-text-focus-padding');
        }
      }
    });
  }

  if ($('.wp-block-media-text.is-style-featured')) {
    $('.wp-block-media-text.is-style-featured').each(function(index, element) {
      $(element).find('.wp-block-media-text__media').append('<div class="ornament-back-a"></div><div class="ornament-front-a"></div><div class="ornament-back-b"></div><div class="ornament-front-b"></div>');
    });
  }

  var controller = new ScrollMagic.Controller();

  // build scene
  new ScrollMagic.Scene({
            triggerElement: ".wp-block-cover:first-child",
            triggerHook: 0, // show, when scrolled 10% into view
            duration: "100%", // hide 10% before exiting view (80% + 10% from bottom)
            offset: -300 // trigger on load
          })
          .setClassToggle(".wp-block-cover:first-child", "visible") // add class to reveal
          .addTo(controller);


  if ($('body.single-brew').length > 0) {
    var tl = new gsap.timeline();

    tl.to($('.cover-ingredients-wrap .left-ingredient'), {duration: 200, transformOrigin: "50%, 50%", y: "-10%", ease: "slow(0.7, 0.7, false)"});
    tl.to($('.cover-ingredients-wrap .right-ingredient'), {duration: 200, transformOrigin: "50%, 50%", y: "-10%", ease: "slow(0.7, 0.7, false)"}, "-=200");

    new ScrollMagic.Scene({
    duration: "150%",
    })
    .setTween(tl)
    .addTo(controller);
  }

  

  $('.entry-content').children().each(function(index, element) {
    var id = $(element).attr('id');
    if (!id) {
      var date = Date.now();
      var rand = Math.floor(Math.random() * 100);
      var id = date.toString() + rand.toString();
      $(element).attr('id', 'block-' + id);
    }

    if ($(element).hasClass('wp-block-cover')) {
      // add a scene for a cover
      if ($(element).is(':first-child')) {
        // skip
      }
      else {
        // do stuff
        new ScrollMagic.Scene({
          triggerElement: ".wp-block-cover:first-child",
          triggerHook: 0, // show, when scrolled 10% into view
          duration: "10%", // hide 10% before exiting view (80% + 10% from bottom)
          offset: 50 // move trigger to center of element
        })
        .setClassToggle(".wp-block-cover:first-child", "visible") // add class to reveal
        .addTo(controller);
      }
    }
    else {

      // our passion animations
      if ($(element).find('.wp-block-media-text')) {
        $(element).find('.wp-block-media-text').each(function(index, textMedia) {

          var textNodes = $(textMedia).find('.wp-block-media-text__content').children();

          $(textNodes).each(function(index, textNode) {
            var textId = $(textNode).attr('id');
            if (!textId) {
              var date = Date.now();
              var rand = Math.floor(Math.random() * 100);
              var textId = date.toString() + rand.toString();
              $(textNode).attr('id', 'element-' + textId);
            }

            new ScrollMagic.Scene({
              triggerElement: "#element-" + textId,
              triggerHook: 0, // show, when scrolled 10% into view
              duration: "200%", // hide 10% before exiting view (80% + 10% from bottom),
              offset: -500,
            })
            .setClassToggle("#element-" + textId, "visible") // add class to reveal
            .addTo(controller);
          });

          if ($(textMedia).hasClass('is-style-featured')) {
            var tl = new gsap.timeline();

            tl.from($(element).find('.ornament-front-b'), {duration: 200, transformOrigin: "50%, 50%", y: "100%", ease: "slow(0.7, 0.7, false)"});
            tl.from($(element).find('.ornament-back-b'), {duration: 200, transformOrigin: "50%, 50%", y: "100%", ease: "slow(0.7, 0.7, false)"}, "-=200");

            tl.from($(element).find('.ornament-front-a'), {duration: 200, transformOrigin: "50%, 50%", y: "100%", ease: "slow(0.7, 0.7, false)"}, "-=200");
            tl.from($(element).find('.ornament-back-a'), {duration: 200, transformOrigin: "50%, 50%", y: "100%", ease: "slow(0.7, 0.7, false)"}, "-=200");

            new ScrollMagic.Scene({
            duration: 500,
            duration: "200%",
            })
            .setTween(tl)
            .addTo(controller);
          }
        });
      }

      if ($(element).find('.wp-block-media-text.is-style-featured').length > 0) {
        // do nothing
      }
      else {
        if ($(element).find('.wp-block-media-text')) {
          var tl = new gsap.timeline();
          var id = $(element).attr('id');

          $('#' + id + ' .ornament-front-a').each(function(index, ornament) {
            if (index === 0) {
              tl.from($(this), {duration: 500, transformOrigin: "50%, 50%", y: "75%", ease: "slow(0.7, 0.7, false)"});
              tl.from($(this).siblings('.ornament-back-a'), {duration: 500, transformOrigin: "50%, 50%", y: "75%", ease: "slow(0.7, 0.7, false)"}, "-=500");
              tl.from($(this).siblings('.hand-ornament'), {duration: 500, transformOrigin: "50%, 50%", y: "75%", ease: "slow(0.7, 0.7, false)"}, "-=500");
            }
            else {
              tl.from($(this), {duration: 500, transformOrigin: "50%, 50%", y: "75%", ease: "slow(0.7, 0.7, false)"}, "-=500");
              tl.from($(this).siblings('.ornament-back-a'), {duration: 500, transformOrigin: "50%, 50%", y: "75%", ease: "slow(0.7, 0.7, false)"}, "-=500");
              tl.from($(this).siblings('.hand-ornament'), {duration: 500, transformOrigin: "50%, 50%", y: "75%", ease: "slow(0.7, 0.7, false)"}, "-=500");
            }
          });

          $('#' + id + ' .ornament-front-b').each(function(index, ornament) {
            if (index === 0) {
              tl.from($(this), {duration: 500, transformOrigin: "50%, 50%", y: "75%", ease: "slow(0.7, 0.7, false)"});
              tl.from($(this).siblings('.ornament-back-b'), {duration: 500, transformOrigin: "50%, 50%", y: "75%", ease: "slow(0.7, 0.7, false)"}, "-=500");
            }
            else {
              tl.from($(this), {duration: 500, transformOrigin: "50%, 50%", y: "75%", ease: "slow(0.7, 0.7, false)"}, "-=500");
              tl.from($(this).siblings('.ornament-back-b'), {duration: 500, transformOrigin: "50%, 50%", y: "75%", ease: "slow(0.7, 0.7, false)"}, "-=500");
            }
          });

          new ScrollMagic.Scene({
          triggerElement: '#' + id,
          duration: 500,
          duration: "100%",
          })
          .setTween(tl)
          .addTo(controller);
        }
      }

      // card float animations
      if ($(element).hasClass('is-style-cards')) {
        var tl = new gsap.timeline();

        new ScrollMagic.Scene({
          triggerElement: "#" + $(element).attr('id'),
          triggerHook: 0, // show, when scrolled 10% into view
          duration: "100%", // hide 10% before exiting view (80% + 10% from bottom)
          offset: -500 // move trigger to center of element
        })
        .setClassToggle("#" + $(element).attr('id') + " h1 > .text", "visible") // add class to reveal
        .addTo(controller);

        new ScrollMagic.Scene({
          triggerElement: "#" + $(element).attr('id'),
          triggerHook: 0, // show, when scrolled 10% into view
          duration: "100%", // hide 10% before exiting view (80% + 10% from bottom)
          offset: -500 // move trigger to center of element
        })
        .setClassToggle("#" + $(element).attr('id') + " .wp-block-group__inner-container > p", "visible") // add class to reveal
        .addTo(controller);

        tl.from($(element).find('h1 > .ornament'), {duration: 1000, transformOrigin: "50%, 50%", y: "150%", ease: "slow(0.7, 0.7, false)"});

        tl.from($(element).find('.wp-block-column:first-child').find('.ornament'), {duration: 1000, transformOrigin: "50%, 50%", y: "150%", ease: "slow(0.7, 0.7, false)"}, "-=1000");
        tl.from($(element).find('.wp-block-column:first-child').find('.ornament-secondary'), {duration: 1000, transformOrigin: "50%, 50%", y: "150%", ease: "slow(0.7, 0.7, false)"}, "-=1000");

        tl.from($(element).find('.wp-block-column:nth-child(2)').find('.ornament'), {duration: 1000, transformOrigin: "50%, 50%", y: "150%", ease: "slow(0.7, 0.7, false)"}, "-=1000");

        tl.from($(element).find('.wp-block-column:nth-child(3)').find('.ornament'), {duration: 1000, transformOrigin: "50%, 50%", y: "50%", ease: "slow(0.7, 0.7, false)"}, "-=1000");

        tl.from($(element).find('.wp-block-column'), {duration: 500, transformOrigin: "50%, 50%", y: "30%", ease: "slow(0.7, 0.7, false)"}, "-=1000");

        new ScrollMagic.Scene({
        duration: 500,
        duration: "200%",
        offset: 250,
        })
        .setTween(tl)
        .addTo(controller);
      }
      // end card float animations

      // vertical brew slider
      if ($(element).hasClass('vertical-brew-slider-block')) {

        new ScrollMagic.Scene({
        triggerElement: '.vertical-brew-slider-block',
        })
        .setClassToggle('.to-top-btn', 'show')
        .addTo(controller);

        new ScrollMagic.Scene({
        triggerElement: '.vertical-brew-slider-block',
        offset: $(window).height() / 2,
        })
        .setClassToggle(".vertical-brew-slider-nav", "fixed")
        .addTo(controller).on("update", function (event) {
          var pos = $(window).scrollTop();
          var top = $('.vertical-brew-slider-block').offset();
          var top = top.top;
          var bottom = top + $('.vertical-brew-slider-block').outerHeight() - $(window).innerHeight();
          if (pos > bottom) {
            $('.vertical-brew-slider-nav').removeClass('fixed').addClass('stuck-bottom');
          }
          else if (pos < top) {
            $('.vertical-brew-slider-nav').removeClass('fixed');
          }
          else {
            $('.vertical-brew-slider-nav').removeClass('stuck-bottom').addClass('fixed');
          }
        });

        $(element).find('.brew-slide').each(function(index, slide) {
          var id = $(slide).attr('id');
          new ScrollMagic.Scene({
          triggerElement: '#' + id,
          duration: "100%",
          })
          .setClassToggle('#' + id + '-indicator', 'active')
          .addTo(controller);
        });

      }
    }

  });

});
